import styled from 'styled-components';
import { Modal } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

export const Container = styled.div``;

export const ModalWrapper = styled(Modal)`
  max-width: 420px;

  @media (max-width: 768px) {
    top: 0;
  }

  .ant-modal-content {
    border-radius: 8px;
    overflow: hidden;
  }
  .ant-modal-body {
    padding: 0px;
  }
`;

export const FormContainer = styled.div`
  padding: 25px;
`;

export const BottomContainer = styled.div`
  background: #f5f5f5;
  padding: 30px;
`;

export const ValueProps = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1em;
`;

export const ValueProp = styled.div`
  display: flex;
  margin-bottom: 0.8emem;
  gap: 1em;
`;

export const ValuePropIcon = styled(CheckCircleOutlined)`
  margin-top: 5px;
  font-size: 20px;
  color: var(--secondary-color-blue);
`;

export const ValuePropText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ValuePropTitle = styled.h4`
  font-weight: bold;
  margin-bottom: 0.2em;
`;

export const ValuePropDescription = styled.p`
  font-size: 0.85em;
`;

export const Title = styled.h3`
  font-weight: bold;
  font-size: 1.5rem;
  margin: ${(props) => (props.margin ? '0' : '')};
`;
